/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChild, ComponentChildren, createContext } from 'preact';
import { Dimension } from '#utils/UNSAFE_visTypes/common';

type OverviewContextProp = {
  height?: number;
  width?: number;
  yAxisSize: number;
  isOverview: boolean;
  overviewRenderer: (props: Dimension) => {
    background: ComponentChildren;
    slidingWindow: ComponentChild;
  };
};

export const OverviewContext = createContext({
  height: undefined,
  width: undefined,
  isOverview: false,
  overviewRenderer: (_) => ({ background: null, slidingWindow: null })
} as OverviewContextProp);
